import { ApiResourceMethod } from '@/api/api-requests-factory';
import {
  ProcessingModeratedTransactionForceTake,
} from '@/models/payment/processing-moderated-transaction-force-take.model';

export class UpdateProcessingModeratedTransactionForceTakeRequest
  extends ApiResourceMethod<ProcessingModeratedTransactionForceTake> {
  public perform(whitelabelSlug: string, playerId: string): Promise<ProcessingModeratedTransactionForceTake> {
    return this.performer.requestWithMapper({
      url: `${whitelabelSlug}/player/${playerId}/bpWlTransactionModerationInfoForceTake`,
    });
  }
}
